import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0015dc74&"
import script from "./editAccountType.component.js?vue&type=script&lang=js&"
export * from "./editAccountType.component.js?vue&type=script&lang=js&"
import style0 from "./AccountTypeEdit.style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports